import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

import { putItem } from '../../../api/items';

import {
  checkAndSetLoadingWithId,
  handleRequestRejection,
  onMatchedRequest,
} from '../../../utils/asyncThunkRequest';
import { generateItemCIDKey } from '../utils/generateItemCIDKey';
import { mergeItemWithUserData } from '../../../utils/items';

export const updateItem = createAsyncThunk(
  'items/updateItem',
  async ({ path, body, params }, { signal, rejectWithValue }) => {
    const source = axios.CancelToken.source();
    signal.addEventListener('abort', () => {
      source.cancel();
    });
    try {
      const [itemRes, userdataRes] = await putItem(
        { path, body, params },
        {
          cancelToken: source.token,
        },
      );
      return mergeItemWithUserData(itemRes, userdataRes);
    } catch (error) {
      return rejectWithValue(error.response.status);
    }
  },
);

export const updateItemExtraReducers = {
  [updateItem.pending]: (state, action) => {
    const itemCIDKey = generateItemCIDKey(action.meta.arg.path);

    checkAndSetLoadingWithId(
      state.items.item.actions.update.request,
      action,
      itemCIDKey,
    );
  },
  [updateItem.fulfilled]: (state, action) => {
    const itemCIDKey = generateItemCIDKey(action.meta.arg.path);

    onMatchedRequest(
      state.items.item.actions.update.request[itemCIDKey],
      action,
      () => {
        state.items.item.byId[itemCIDKey] = action.payload;
        if (!state.items.item.allIds.includes(itemCIDKey)) {
          state.items.item.allIds.push(itemCIDKey);
        }
        state.isShownNewBuzzNotification = false;
      },
    );
  },
  [updateItem.rejected]: (state, action) => {
    handleRequestRejection(
      state.items.item.actions.update.request[
        generateItemCIDKey(action.meta.arg.path)
      ],
      action,
    );
  },
};
